module.exports = __webpack_public_path__ + "img/Screen_Shot_9.9f9ed8d4.png";